import { AddressValue } from './../../../shared/model/address-value';
import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Address } from '../../../shared/model/address';
import { PhonePipe } from '../../../shared/pipe/phone.pipe';
import { CepPipe } from '../../../shared/pipe/cep.pipe';
import { Branch } from '../../../shared/model/branch';
import { Customer } from '../../../shared/model/customer';
import { ManagementContact } from '../../../shared/model/management-contact';
import { BranchService } from '../../../shared/service/branch.service';
import { CustomerService } from '../../../shared/service/customer.service';
import { ToastService } from '../../../shared/service/toast.service';

declare var Materialize: any;

@Component({
  selector: 'tx-branch-create-update',
  templateUrl: './branch-create-update.component.html',
  styleUrls: ['./branch-create-update.component.css']
})
export class BranchCreateUpdateComponent implements OnInit, AfterViewChecked {
  newBranch: Branch;
  customers: Array<Customer>;
  partialTitle: string;
  customerAttributesTree = ['name'];
  private editMode = false;
  private branchId: number;
  private phonePipe: PhonePipe;
  private cepPipe: CepPipe;

  constructor(private _branchService: BranchService,
              private _customerService: CustomerService,
              private _route: ActivatedRoute,
              private _router: Router,
              private _toastService: ToastService) {
    this.setEmptyEntities();
    this.setPipes();
    this.editModeVerify();
    this.setUpObservers();
  }

  ngOnInit() {
  }

  ngAfterViewChecked() {
    try {
      Materialize.updateTextFields();
    } catch (e) { }
  }

  save() {
    this.sanitizeBranch();

    if (!this.newBranch.address.number || !this.newBranch.address.number.trim()) {
      this.newBranch.address.number = AddressValue.WITHOUT_NUMBER;
    }

    if (this.editMode) {
      this._branchService.update(this.newBranch);
    } else {
      this._branchService.save(this.newBranch);
    }
  }

  findCustomer(name: string) {
    this._customerService.findByName(name);
  }

  editModeVerify() {
    this.partialTitle = 'Cadastrar ';
    this._route.params.subscribe(params => {
      if (params['id']) {
        this.editMode = true;
        this.branchId = +params['id'];
        this._branchService.findById(this.branchId);
        this.partialTitle = 'Editar ';
      }
    });
  }

  updateIntegrationValue() {
    this.newBranch.needIntegration = !this.newBranch.needIntegration;
  }

  private sanitizeBranch() {
    const emptyBranch = { address: { } };
    const isEmpty = JSON.stringify(this.newBranch.managementContact) === JSON.stringify(emptyBranch);
    if (isEmpty) {
      this.newBranch.managementContact = null;
    }
    if (!this.newBranch.needIntegration) {
      this.newBranch.needIntegration = false;
    }
  }

  private setUpObservers() {
    this.setUpFindAction(this._branchService.find$);
    this.setUpSaveUpdateAction(this._branchService.save$);
    this.setUpSaveUpdateAction(this._branchService.update$);
    this.setUpErrorAction(this._branchService.error$);
    this.setUpFindCustomers(this._customerService.find$);
  }

  private setUpFindAction(observable) {
    observable
      .filter(branch => branch instanceof Branch)
      .subscribe(
        (branch: Branch) => {
          this.newBranch = branch;
          if (!this.newBranch.managementContact) {
            this.setEmptyManagementContact();
          }
        }
      );
  }

  private setUpErrorAction(observable) {
    observable
      .subscribe(error => this.showMessage(error.text));
  }

  private setUpSaveUpdateAction(observable: Observable<Branch>) {
    observable
      .subscribe(() => {
        this.goBack();
      });
  }

  private setUpFindCustomers(observable) {
    observable
      .filter(customers => customers instanceof Array)
      .subscribe(customers => this.customers = customers);
  }

  setPipes() {
    this.phonePipe = new PhonePipe();
    this.cepPipe = new CepPipe();
  }

  setEmptyEntities() {
    this.newBranch = new Branch();
    this.newBranch.address = new Address();
    this.customers = new Array();
    this.setEmptyManagementContact();
  }

  private setEmptyManagementContact() {
    this.newBranch.managementContact = new ManagementContact();
    this.newBranch.managementContact.address = new Address();
  }

  applyPhoneMask(event) {
    this.newBranch.managementContact.phone = this.phonePipe.transform(event.target.value, event.key);
  }

  applyCepMask(event) {
    return this.cepPipe.transform(event.target.value, event.key);
  }

  goBack() {
    this._router.navigate(['branches/list']);
  }

  showMessage(message) {
    this._toastService.showMessage(message, 4000);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/branch/component/branch-create-update/branch-create-update.component.ts